module.exports = __webpack_public_path__ + "img/6.35e67824.jpeg";